export default "__VITE_ASSET__BgsA__WI__"